<template>
  <div>
    <!--  导航  -->
    <div class="nav-all">
      <div style="width:90%;margin: 0 auto">
        <div class="nav-logo">
          <img src="../../assets/logo-nav.png">
        </div>
        <ul class="nav-list">
          <li ><router-link :class="{active:this.$route.name=='HomeYjj'}" :to="{name:'HomeYjj',params:{nav:'shouye'}}">首页</router-link></li>
          <li ><router-link :class="{active:this.$route.name=='intro'||this.$route.name=='honor'}" :to="{name:'intro',params:{nav:'jianjie'}}">馆内简介</router-link></li>
          <li ><router-link :class="{active:this.$route.name=='NewsListYjj'||this.flag=='dongtai'}" :to="{name:'NewsListYjj',params:{nav:'dongtai'}}">资讯动态</router-link></li>
          <li ><router-link :class="{active:this.$route.name=='DisplayListYjj'||this.$route.path=='/yjj/pic'}" :to="{name:'DisplayListYjj',params:{nav:'zhanlan'}}">陈列展览</router-link></li>
          <li ><router-link :class="{active:this.$route.name=='CulturalListYjj'||this.$route.path=='/yjj/culcont'}" :to="{name:'CulturalListYjj',params:{nav:'wenwu'}}">馆藏文物</router-link></li>
          <li ><router-link :class="{active:this.$route.name=='ResearchListYjj'||this.flag=='yanjiu'}" :to="{name:'ResearchListYjj',params:{nav:'yanjiu'}}">学术研究</router-link></li>
<!--          <li ><router-link :class="{active:this.$route.name=='EduListYjj'||this.flag=='huodong'}" :to="{name:'EduListYjj',params:{nav:'huodong'}}">社教活动</router-link></li>-->
          <li ><router-link :class="{active:this.$route.name=='MemoryYjj'}" :to="{name:'MemoryYjj',params:{nav:'yinglie'}}">缅怀英烈</router-link></li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "HeaderYjj",
  data(){
    return{
      flag:'',
      id:0,
    }
  },
  methods:{
    activeNav:function(){

      console.log(11111)
    },
    getOneByID:function(uid){
      request({
        method:'GET',
        url:'articles/'+uid,
      }).then(res =>{

          if(res.data.columnId==4||res.data.columnId==5){
            this.flag = 'dongtai'
          }
        if(res.data.columnId==7||res.data.columnId==12||res.data.columnId==13){
          this.flag = 'yanjiu'
        }
        if(res.data.columnId>=8&&res.data.columnId<=11){
          this.flag = 'huodong'
        }
      },err=>{
        console.log(err)
      })
    },
  },
  mounted:function() {
    if(this.$route.name == 'ArticleContentYjj'){
      this.id = this.$route.params.id;
      this.getOneByID(this.id)
    }

  }
}

</script>

<style scoped>

  .nav-all{
    background: #9E1A28;
    height:80px;
    line-height:80px;
  }
  .nav-logo{
    float: left;
    width:15%;
    height:80px;
    text-align: center;

  }
  .nav-logo img{
    height: 80px;
  }
  .nav-list{
    float: right;
    width:85%;
    display: flex;
  }
  .nav-list li{
    flex: 1;
    color: #FFECB2;
    font-size: 20px;
    font-weight: bold;
  }
  .nav-list li a{
    color: #FFECB2;
    text-decoration: none;
    display: inline-block;
    height:76px;
    width:100px;
  }
  .clear{
    clear:both;
  }
  .active{
    border-bottom: 4px solid #FFECB2;
  }

</style>
